export default "__VITE_ASSET__CTWVmSd7__"